import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/index.css'
import { applyPrefs } from './utils/appPrefs'

// La publicité d'ouverture (App Open AdMob) est gérée côté natif
// Android : voir android/app/src/main/java/com/icreo/johnny100/MainActivity.java

// Taille du texte, animations… appliquées avant le premier affichage
applyPrefs()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
